import { ContentFormat } from '@/domain/models/content/content-format'
import { Subtype } from '@/domain/models/content/subtype'
import { EnrollmentStatus } from '@/domain/models/enrollment/status'
import { createLocalTimezoneDateFromString } from '@/main/helpers'
import {
  EngagementWorkflow,
  EnrollmentEngagementData,
  EnrollmentEngagementResponse,
  SelectedEngagementOption
} from './enrollment-engagement-service-types'

export const formatEnrollmentEngagement = (
  apiData: EnrollmentEngagementResponse | null | undefined
): EnrollmentEngagementData | null => {
  // Body vazio/ausente da API — degrada para "sem engagement" em vez de
  // lançar TypeError ao acessar apiData.workflow.
  if (!apiData) {
    return null
  }

  const toSnakeCase = (value: string) => value.replace(/([A-Z])/g, '_$1').toUpperCase()
  const workflow =
    Object.values(EngagementWorkflow).find(v => toSnakeCase(v) === apiData.workflow) ?? null

  if (!workflow) {
    return null
  }

  if (
    !apiData.step &&
    workflow !== EngagementWorkflow.CONCLUSION &&
    workflow !== EngagementWorkflow.UNKNOWN_PROGRESS
  ) {
    return null
  }

  return {
    name: apiData.name,
    institutionName: apiData.institutionName,
    subtype: apiData.subTypeId ? Subtype.getById(Number(apiData.subTypeId)) : null,
    format: apiData.format ? ContentFormat.getByName(apiData.format) ?? null : null,
    step: apiData.step,
    workflow,
    cancellationDate: createLocalTimezoneDateFromString(apiData.cancellationDate),
    enrollmentStatus: EnrollmentStatus.getById(apiData.status) ?? null,
    engagementChoice: apiData.engagementChoice
      ? Object.values(SelectedEngagementOption).find(v => v === apiData.engagementChoice) ?? null
      : null,
    orderId: apiData.orderId,
    coursePrice: apiData.coursePrice,
    courseCategoryId: apiData.courseCategoryId,
    coursePlan: apiData.coursePlan
  }
}
